import { Row } from "components/Row";
import type { RowAdapterProps } from "./Row.d";

const RowAdapter = ({
  blok: {
    pyMobile,
    mtMobile,
    pyDesktop,
    mtDesktop,
    mbMobile,
    mbDesktop,
    bgStyle,
    id,
    display,
    content,
    pxMobile,
    pxDesktop,
    pyTablet,
    mtTablet,
    mbTablet,
    pxTablet,
  },
}: RowAdapterProps) => (
  <Row
    pyMobile={pyMobile}
    mtMobile={mtMobile}
    pxMobile={pxMobile || "16px"}
    mbMobile={mbMobile}
    pyTablet={pyTablet}
    mtTablet={mtTablet}
    mbTablet={mbTablet}
    pxTablet={pxTablet}
    pyDesktop={pyDesktop}
    mtDesktop={mtDesktop}
    mbDesktop={mbDesktop}
    pxDesktop={pxDesktop}
    bgStyle={bgStyle}
    id={id}
    display={display}
    content={content}
  />
);

export default RowAdapter;
